import hire1 from '../assets/hire/hire-1.png';
import hire2 from '../assets/hire/hire-2.png';
import hire3 from '../assets/hire/hire-3.png';
import hire4 from '../assets/hire/hire-4.png';
import avatar from '../assets/avatars/testimonial-male.png';
import blog1 from '../assets/blog-images/blog-1.png';
import blog2 from '../assets/blog-images/blog-2.png';
import blog3 from '../assets/blog-images/blog-3.png';

export const peopleToHire = [
  {
    id: 1,
    name: 'Antonio Voåaska',
    job: 'UI Designer',
    from: 'California',
    avatar: hire1,
  },
  {
    id: 2,
    name: 'Rashed Ka',
    job: 'Motion Designer',
    from: 'Bangladesh',
    avatar: hire2,
  },
  {
    id: 3,
    name: 'Zubayer Al Hasan',
    job: 'Developer',
    from: 'Norway',
    avatar: hire3,
  },
  {
    id: 4,
    name: 'Jannatul Ferdaus',
    job: 'YouTuber',
    from: 'Turkey',
    avatar: hire4,
  },
];

export const accordionData = [
  {
    id: 1,
    title: 'Seamless Search',
    content:
      'It only takes 5 minutes. Set-up is smooth and simple, with fully customisable page design to reflect your brand.',
  },
  {
    id: 2,
    title: 'Hire top talents',
    content: '',
  },
];

export const testimonialData = [
  {
    id: 1,
    title: 'Impressive!',
    quote: `"This is absolutely unique and clean design that I'm looking for. Also, the code quality is great!"`,
    avatar: avatar,
    name: 'Zubayer Al Hasan',
    location: 'Dhaka',
  },
  {
    id: 2,
    title: 'Nice work',
    quote: `"This is absolutely unique and clean design that I'm looking for. Also, the code quality is great!"`,
    avatar: avatar,
    name: 'Rashed ka',
    location: 'Alaska',
  },
  {
    id: 3,
    title: 'Incredible!',
    quote: `"This is absolutely unique and clean design that I'm looking for. Also, the code quality is great!"`,
    avatar: avatar,
    name: 'Sara Thompson',
    location: 'San Francisco',
  },
  {
    id: 4,
    title: 'Fantastic!',
    quote: `"This is absolutely unique and clean design that I'm looking for. Also, the code quality is great!"`,
    avatar: avatar,
    name: 'Matt Smith',
    location: 'San Francisco',
  },
];

export const blogData = [
  {
    id: 1,
    image: blog3,
    title: `A Discount Cartridge dsu
  is Better Ever.`,
    date: '23 Apr 2020',
    url: 'https://jobi.com',
  },
  {
    id: 2,
    image: blog2,
    title: `Truck Side Advertising Isn
It Time for action.`,
    date: '23 Apr 2020',
    url: 'https://jobi.com',
  },
  {
    id: 3,
    image: blog1,
    title: `A discount cartridge dsu
  is better ever.`,
    date: '23 Apr 2020',
    url: 'https://jobi.com',
  },
];

export const footerLinksData = [
  {
    id: 1,
    title: 'Pricing',
    url: 'https://www.codeacademy.com',
  },
  {
    id: 2,
    title: 'About us',
    url: 'https://www.codeacademy.com',
  },
  {
    id: 3,
    title: 'Careers',
    url: 'https://www.codeacademy.com',
  },
  {
    id: 4,
    title: 'Blog',
    url: 'https://www.codeacademy.com',
  },
];

export const footerProductsData = [
  {
    id: 1,
    title: 'Take the Tour',
    url: 'https://www.codeacademy.com',
  },
  {
    id: 2,
    title: 'Live chat',
    url: 'https://www.codeacademy.com',
  },
  {
    id: 3,
    title: 'Self-service',
    url: 'https://www.codeacademy.com',
  },
  {
    id: 4,
    title: 'Mobile',
    url: 'https://www.codeacademy.com',
  },
  {
    id: 5,
    title: 'Collaboration',
    url: 'https://www.codeacademy.com',
  },
  {
    id: 6,
    title: 'Reviews',
    url: 'https://www.codeacademy.com',
  },
];
export const footerLegalData = [
  {
    id: 1,
    title: 'Terms of use',
    url: 'https://www.codeacademy.com',
  },
  {
    id: 2,
    title: 'Terms & Conditions',
    url: 'https://www.codeacademy.com',
  },
  {
    id: 3,
    title: 'Privacy',
    url: 'https://www.codeacademy.com',
  },
  {
    id: 4,
    title: 'Cookie Policy',
    url: 'https://www.codeacademy.com',
  },
];
